module.exports = __webpack_public_path__ + "static/media/mtl.9cb2df25.svg";